import { shape, string, arrayOf, bool } from 'prop-types';

const UserPropTypes = shape({
  type: string,
  expiresAt: string,
  affiliations: arrayOf(shape({})),
  isLoggedIn: bool,
  isCounselor: bool,
  isStudent: bool,
  isGuardian: bool,
  isLorWriter: bool,
  isSupervisor: bool,
  isMember: bool,
  isDemoStudent: bool,
  isOAuth2Authenticated: bool,
  isAlumni: bool,
});

const UserDefaultProps = {};

// eslint-disable-next-line import/prefer-default-export
export { UserPropTypes, UserDefaultProps };
